import type { JSX, ParentComponent } from "solid-js";
import "./MetaList.css";

/** Horizontal row of muted metadata items (time, kind, size, etc.) separated by middots. */
export const MetaList: ParentComponent<{ style?: JSX.CSSProperties }> = (
	props,
) => {
	return (
		<ul class="metadata" style={props.style}>
			{props.children}
		</ul>
	);
};
